import { render, staticRenderFns } from "./PublishDialog.vue?vue&type=template&id=ac45d6c8&scoped=true&"
import script from "./PublishDialog.vue?vue&type=script&lang=js&"
export * from "./PublishDialog.vue?vue&type=script&lang=js&"
import style0 from "./PublishDialog.vue?vue&type=style&index=0&id=ac45d6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45d6c8",
  null
  
)

/* custom blocks */
import block0 from "./PublishDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports